import { Add } from '@mui/icons-material';
import { DialogProps, IconButton } from '@mui/material';
import { Loader } from 'components';
import { FC, useEffect, useMemo, useState } from 'react';
import { getImage } from 'services';
import { TransactionImage } from 'types';
import { ImageCapture, ImagePreview, UploadImages, useImages } from '../../../new-transaction/transaction-images';
import { useEditTransaction } from './edit-transaction.context';
import './edit.scss';



const ImagesConsumer: FC<DialogProps> = props => {
    const { preview, webcam } = useImages();
    const { images, addImage, deleteImage } = useEditTransaction();
    if (preview) return <ImagePreview immutable images={images.map(img => ({ imageBase64: img}))} deleteImage={deleteImage} />;
    if (webcam) return <ImageCapture addImage={addImage} />;
    return <UploadImages images={images.map(img => ({ imageBase64: img }))} addImage={addImage} deleteImage={deleteImage} {...props} />;
  };
  
  const ImageDialog: FC<DialogProps> = props => (
      <ImagesConsumer {...props} />
    
  );

const ImageCard: FC<{image: TransactionImage, setPreview: (src: string) => void}> = ({ image, setPreview }) => {
    const [source, setSource] = useState<string | undefined>(undefined);

    useEffect(() => {
        getImage(image.imageKey).then(img => img && setSource(img.replace(/\\r\\n/g, '')));
    }, [])

    return (
        <div className="thumbnail-container">
            {
                !!source
                    ? (
                        <img
                            src={source}
                            alt=""
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                                objectPosition: 'center'
                            }}
                            onClick={() => setPreview(source)}
                        />
                    )
                    : (
                        <div
                            style={{ display: 'block', width: '100%', height: '100%' }}
                        >
                            <Loader loading={true} className='loader' />
                        </div>
                    )
            }
        </div>
    );
}

const NewImageCard: FC<{
    image: string,
    setPreview: (src: string) => void,
    deleteImage: (src: string) => void
}> = ({ image, setPreview, deleteImage }) => {

    return (
        <div className="thumbnail-container">
            <img
                src={image}
                alt=""
                onClick={() => setPreview(image)}
            />
            <div
                className="delete-button"
                onClick={() => deleteImage(image)}
            >
                <IconButton color='primary'>
                    x
                </IconButton>
            </div>
        </div>
    );
}

const EditImages: FC = () => {
    const { transaction, images: newImages, deleteImage } = useEditTransaction();
    const { setPreview } = useImages();

    /* order now preserved by transactionImage.index, where signature.index == 0 */
    /* old transactionImages may not have index, so we assume signature is first */
    const [signature, ...images]: TransactionImage[] = useMemo(() => {
    const transactionImages: TransactionImage[] = Object.assign([], transaction?.images);
    return transactionImages.sort((i0, i1) => (i0.index ?? 1) - (i1.index ?? 1));
    }, [transaction?.images]);
    const [showAddImage, setShowAddImage] = useState<boolean>(false);

    return (
        <div className='card-primary'>
            <div className='cardo-header px-3'>
                <h4>IMAGES</h4>
            </div>
            <div className='card-body image-list'>
                {
                    images.map(img => <ImageCard setPreview={setPreview} image={img} />)
                }
                {
                    newImages.map(img => <NewImageCard deleteImage={deleteImage} setPreview={setPreview} image={img} />)
                }
                <div 
                    className="thumbnail-container-add" 
                    onClick={() => setShowAddImage(true)}
                >
                    <IconButton>
                        <Add fontSize="large" />
                    </IconButton>
                </div>
            </div>
            <ImageDialog open={showAddImage} onClose={() => setShowAddImage(false)} />
        </div>
    );
};

export default EditImages;